import BaseModule from "./base-module";

class Order extends BaseModule {
    getOrderDeliveryFee(payload) {
        return this.post("/v1/order/deliveryFeeSetting", payload);
    }

    createOrder(payload) {
        return this.post("/v1/order/takeaway", payload);
    }

    // 获取当前登录用户订单列表
    loadOrder(payload) {
        return this.post("/v1/order/search", payload);
    }

    // 获取当前登录用户订单列表
    loadAppointmentOrder(params) {
        console.log('payload', params)
        return this.get("/v1/order/reserve", {
            params
        });
    }

    // 获取指定的订单祥情
    loadOrderDetail(params) {
        return this.get("/v1/order/details", {params});
    }
    loadAppointmentOrderDetail(params) {
        return this.get("/v1/order/reserve/" + params.guid);
    }

    // 取消订单
    cancelOrder(params) {
        return this.post("/v1/order/cancel", params);
    }

    // 计算订单价格
    calculateOrder(params) {
        if (params.items.length == 0) {
            return;
        }
        return this.post("/v1/order/calculate", params);
    }

    // 计算订单价格.不需要登录
    calculateCommodity(params) {
        return this.post("/v1/commodity/calculate", params);
    }

    // 查询商家邮编
    queryZipcode(params) {
        console.log("params", params);
        return this.gett(
            "/v1/isDelivery?deliveryType=" +
            params.deliveryType +
            "&storeGuid=" +
            params.storeGuid +
            "&zipCode=" +
            params.zipCode
        );
    }

    // 创建支付请求时需要先调该接口拿到需要的参数
    redsystransaction(params) {
        return this.post("/v1/redsystransaction", params);
    }

    createReserva(params) {
        return this.post("/v1/order/reserve", params);
    }

    // 执行支付接口
    executePay(params) {
        return this.post("/v1/stripe/ExecutePay", params);
    }

    // 获取支付配置接口
    getStripe(params) {
        return this.get("/v1/stripe/getStripe", {params});
    }

    // 准备支付接口
    readyToPay(params) {
        return this.post("/v1/stripe/readyToPay", params);
    }

    // 用户端获取配送费用接口
    storeDeliveryArea(params) {
        return this.get("/v1/storeDeliveryArea", params);
    }

    // 用户端获取配送费用接口
    getBusinessHours(params) {
        return this.get("/v1/businessHours", params);
    }

    // 根据邮编获取配送费用
    getStoreDeliveryArea(params) {
        // return this.get("/v1/storeDeliveryArea?zipCode="+params.zipCode+'&storeGuid='+params.storeGuid);
        return this.get("/v1/storeDeliveryArea?zipCode", params);
    }

    // getStoreInfo(params) {
    //   return this.get("/v1/store", { params });
    // }
}

export default new Order();
